// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JvtLm","image":"styles_image__1yvj8","forgotPasswordText":"styles_forgotPasswordText__s8Km6","resetLink":"styles_resetLink__ZT-K9"};